





















































import {Component, Prop, Vue} from 'vue-property-decorator';
import Button from "primevue/button";
import ProgressSpinner from 'primevue/progressspinner';
import OrderList from 'primevue/orderlist';
import Message from 'primevue/message';
import ProgressBar from 'primevue/progressbar';
import AutoComplete from 'primevue/autocomplete';
import Dialog from 'primevue/dialog'
import FileUpload from './FileUpload'
import download from "downloadjs";
import {PDFDocument} from "pdf-lib";
import axios from "axios";
import {v4 as uuidv4} from 'uuid';

@Component({
    components: {
        Button: Vue.extend(Button),
        ProgressSpinner: Vue.extend(ProgressSpinner),
        OrderList: Vue.extend(OrderList),
        Message: Vue.extend(Message),
        ProgressBar: Vue.extend(ProgressBar),
        AutoComplete: Vue.extend(AutoComplete),
        Dialog: Vue.extend(Dialog),
        FileUpload: Vue.extend(FileUpload),
    }
})
export default class LocalCombine extends Vue {
    excelArr = ['csv', 'xls', 'xlsb', 'xlsx', 'xlt', 'xltx'];
    wordArr = ['docx', 'doc', 'dot', 'dotx', 'wps', 'wpd', 'rtf', 'wri', 'log'];
    supportedFormat = this.excelArr.concat(this.wordArr).concat(['pdf', 'png', 'jpg']);
    files: any = [];
    selectedFile: any = null;
    blockButton: any = false;
    filesCount: any = 0;
    displayModal: any = false;
    loadPdf: any = false;
    pdfSrc: any = null;
    mergeProgress: any = 0;
    combinedPdf: any = null;
    convertRecords: any = [];
    convertTime: any = 0;
    totalTime: any = null;
    success: any = false;
    successMsg: any = null;
    error: any = false;
    errorMsg: any = null;

    async customUpload(event: any) {
        this.files = [];
        for (const file of event.files) {
            if (file.name.startsWith('.')) continue
            this.files.push(file)
        }
        this.files.sort((a: any, b: any) => (a.webkitRelativePath.toLowerCase() > b.webkitRelativePath.toLowerCase()) ? 1 : ((b.webkitRelativePath.toLowerCase() > a.webkitRelativePath.toLowerCase()) ? -1 : 0));
    }

    async combineFiles() {
        this.success = false;
        this.error = false;
        this.convertRecords = [];
        this.convertTime = 0;
        this.totalTime = 0;
        this.filesCount = 0;
        this.mergeProgress = 0;

        const mergedPdf = await PDFDocument.create();
        mergedPdf.setTitle('Output')
        let convertToPdf = null;
        const jobId = uuidv4();
        const filesArr = [];

        for (const file of this.files) {
            const fileExt = file.name.substr(file.name.lastIndexOf('.') + 1);
            const buffer = await file.arrayBuffer();

            if (!this.supportedFormat.includes(fileExt)) {
                this.error = true;
                this.errorMsg = `Files in ${fileExt} were not supported. Please try again with pdf, word or excel formats.`;
                return;
            }

            filesArr.push({
                jobId: jobId,
                name: file.name,
                extension: fileExt,
                size: file.size,
                directory: file.webkitRelativePath,
                order: this.filesCount + 1
            })

            // images: 'png' or 'jpg'
            if (fileExt === 'png' || fileExt === 'jpg') {
                try {
                    const image = fileExt === 'png' ? await mergedPdf.embedPng(buffer) : await mergedPdf.embedJpg(buffer);
                    const dims = image.scale(0.5);
                    const page = mergedPdf.addPage();
                    page.drawImage(image, {
                        x: page.getWidth() / 2 - dims.width / 2,
                        y: page.getHeight() / 2 - dims.height / 2,
                        width: dims.width,
                        height: dims.height,
                    });
                    continue;
                } catch (e) {
                    this.error = true;
                    this.errorMsg = `Cannot convert ${file.Name} to pdf. Please try again later.`;
                    return;
                }
            }

            // office-convert server
            if (this.wordArr.includes(fileExt) || this.excelArr.includes(fileExt)) {
                try {
                    convertToPdf = await axios.post(
                        'https://ocp.dita1.fhk-app.com/convert',
                        `{ "data": "${this.arrayBufferToBase64(buffer)}" }`,
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    this.convertRecords.push({
                        file: file.Name,
                        time: Math.round(convertToPdf.data.time / 1000)
                    });
                    this.convertTime += Math.round(convertToPdf.data.time / 1000)
                } catch (e) {
                    this.error = true;
                    this.errorMsg = `Cannot convert ${file.Name} to pdf. Please try again later.`;
                    return;
                }
            }

            try {
                const pdf = await PDFDocument.load(convertToPdf ? /*(convertToPdf.data.Files[0]).FileData*/ convertToPdf.data.result : buffer);
                const copyPage = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
                copyPage.forEach(el => mergedPdf.addPage(el));
            } catch (e) {
                this.error = true;
                this.errorMsg = `Cannot combine files into pdf. Please try again later.`;
                return;
            }
            convertToPdf = null;
            this.filesCount++;
            this.mergeProgress = Math.floor(this.filesCount * 100 / this.files.length);
        }

        // add page number on each pages
        // const pages = await mergedPdf.getPages();
        // const helveticaFont = await mergedPdf.embedFont(StandardFonts.Helvetica);
        // for (const [i, page] of Object.entries(pages)) {
        //     page.drawText(`${+i + 1}`, {
        //         x: page.getWidth() / 2,
        //         y: 10,
        //         size: 15,
        //         font: helveticaFont,
        //         color: rgb(0, 0, 0)
        //     });
        // }

        this.combinedPdf = await mergedPdf.save();
        const blob = new Blob([this.combinedPdf], {type: 'application/pdf'})
        this.$store.commit('updateOutputBlob', blob)

        // add file details to DB
        try {
            await axios.post(
                'https://ocp.dita1.fhk-app.com/files',
                `{ "data": ${JSON.stringify(filesArr)} }`,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
        } catch (e) {
            this.error = true;
            this.errorMsg = `Cannot add files to database. Please try again later.`;
            return;
        }
    }

    async downloadFiles() {
        const start = Date.now();
        this.blockButton = true;

        await this.combineFiles();

        if (this.combinedPdf) {
            const now = new Date()
            const date = [now.getFullYear(), now.getMonth() + 1, now.getDate()].map(d => d.toString().length === 1 ? "0" + d : d);
            const time = [now.getHours(), now.getMinutes(), now.getSeconds()].map(d => d.toString().length === 1 ? "0" + d : d);
            // const teamName = this.selectedTeam.displayName.includes('Agreement No.') ? (this.selectedTeam.displayName.split('Agreement No.')[1]).trim() : this.selectedTeam.displayName;
            const fileName = `${date.join("_")}-${time.join("_")}`
            download(this.combinedPdf, `${fileName}.pdf`, "application/pdf");

            // setTimeout(() => {
            //     window.location.reload();
            // }, 2000);

            this.totalTime = Math.round((Date.now() - start) / 1000);
            this.success = true;
            this.successMsg = `Download successfully. Total time used: ${this.totalTime} seconds. Result is available in the Output Tab`;
        }

        this.blockButton = false;
    }

    openModal(selectedFile: any) {
        if (selectedFile) {
            this.displayModal = true
        }
    }

    async onDialogShow(selectedFile: any) {
        this.loadPdf = true;
        const buffer = await selectedFile[0].arrayBuffer();
        const fileExt = selectedFile[0].name.substr(selectedFile[0].name.lastIndexOf('.') + 1);

        if (fileExt === 'pdf') {
            const blob = new Blob([buffer], {type: 'application/pdf'})
            this.pdfSrc = URL.createObjectURL(blob)
        } else if (this.wordArr.includes(fileExt) || this.excelArr.includes(fileExt)) {
            try {
                const base64String = await axios.post(
                    'https://ocp.dita1.fhk-app.com/convert',
                    `{ "data": "${this.arrayBufferToBase64(buffer)}" }`,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );
                this.pdfSrc = `data:application/pdf;base64,${base64String.data.result}`
            } catch (e) {
                this.error = true;
                this.errorMsg = `Error occurred in previewing the file. Please try again later.`;
                return;
            }
        }

        this.loadPdf = false;
    }

    arrayBufferToBase64(buffer: any) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
}
